import { CommonUtilities } from 'commonUtils';
import PieChart from 'components/Charts/PieChart';
import HorizontalBarChart from 'components/Charts/HorizontalBarChart';
import VerticalBarChart from 'components/Charts/VerticalBarChart';
import contractServices from 'components/Contracts/contractServices';
import { Filter } from 'filter';
import { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import StackedBarChart from 'components/Charts/StackedBarChart';

export default function IndicatorChart(detail: any) {

    console.log(detail)

    let [barIndicator, setbarIndicator] = useState<any>([]);
    let [selectPeriod, SetSelectedPeriod] = useState<any>([]);
    let [periodListing, setPeriodListing] = useState<any>([]);
    let [contractDetail, setContractDetail] = useState<any>([]);
    let [horBarIndicator, sethorBarIndicator] = useState<any>([]);
    let [pieChartIndicator, setpieChartIndicator] = useState<any>([]);

    var contractPayload = {
        contractRefNum: detail?.paramDetail?.contract,
        export: 0,
        indicatorCode: "period_balance",
        pageNumber: 1,
        pageSize: 10,
        period: "2022-06-30T00:00:00",
        searchFor: "",
    }

    useEffect(() => {

        if (detail.indicatorChartDetail) {

            if (detail?.paramDetail?.period && detail?.paramDetail?.period?.periodDesc) {
                selectPeriod = detail?.paramDetail?.period;
                SetSelectedPeriod(selectPeriod)
            }

            if (detail?.paramDetail?.contract) {
                contractServices.overview({ contractRefNum: detail?.paramDetail?.contract }).then((respond: any) => {
                    contractDetail = respond
                    setContractDetail(contractDetail)

                    if (respond?.contact?.cycle === "Monthly") {
                        getPeriodListing(1)
                    }
                    if (respond?.contact?.cycle === "Quarterly") {
                        getPeriodListing(2)
                    }

                    if (respond?.contact?.cycle === "Bi-Annually") {
                        getPeriodListing(3)
                    }
                })

            }

            chartIndicator();
        }
    }, [detail]);

    const getPeriodListing = (accountingPeriod: any) => {
        contractServices.periodCount({ accountingPeriod: accountingPeriod }).then((res) => {
            periodListing = res;
            setPeriodListing(periodListing)

            if (!selectPeriod) {
                selectPeriod = res.filter((e: any) => e.periodCurrent == 1)[0]
                SetSelectedPeriod(selectPeriod)
            }

            console.log(selectPeriod)

        })
    }

    const closeIndicatorChartDrawer = () => {
        detail.closeIndicatorChartDrawer()
    }

    const prevPeriod = () => {
        console.log(selectPeriod)
        const index = periodListing.findIndex((e: any) => e.periodDesc == selectPeriod.periodDesc)
        console.log(index)

        console.log(periodListing[index - 1])

        selectPeriod = periodListing[index - 1];
        SetSelectedPeriod(selectPeriod);

    }

    const nextPeriod = () => {
        console.log(selectPeriod)
        const index = periodListing.findIndex((e: any) => e.periodDesc == selectPeriod.periodDesc)
        console.log(index)

        console.log(periodListing[index + 1])

        selectPeriod = periodListing[index + 1];
        SetSelectedPeriod(selectPeriod);
    }

    const chartIndicator = () => {
        console.log(selectPeriod)
        console.log(Filter.NumToDate(selectPeriod.periodDesc))
        contractPayload.period = (Filter.NumToDate(selectPeriod.periodDesc)).toString();
        console.log(contractPayload)
        contractServices.contractIndicatorChart(contractPayload).then((repond: any) => {
            barIndicator = repond.barIndicator ?? []
            setbarIndicator(barIndicator)
            horBarIndicator = repond.horBarIndicator ?? []
            sethorBarIndicator(horBarIndicator)
            pieChartIndicator = repond.pieChartIndicator ?? []
            setpieChartIndicator(pieChartIndicator)

        })
    }

    const CallChart = (data: any, name: any) => {

        var backgroundColor: any = [];
        var ChartLabel_list: any = [];
        var ChartData_list: any = [];

        var xName = 'value'
        var yName = 'Code'
        var LabelName = 'Code'

        console.log(data)

        if (name == "barIndicator") {
            LabelName = 'Sales by format for period'
            ChartLabel_list = ['Sales Digital', 'Sales Physical', 'Sales Licensing', 'Costs', 'Advances', 'Net reserves', 'Payments/Adjustments']
            ChartData_list = [
                data.filter((e: any) => e.label == 'SD')[0]?.value ?? 0.0,
                data.filter((e: any) => e.label == 'SI')[0]?.value ?? 0.0,
                data.filter((e: any) => e.label == 'SL')[0]?.value ?? 0.0,
                data.filter((e: any) => e.label == 'C')[0]?.value ?? 0.0,
                data.filter((e: any) => e.label == 'A')[0]?.value ?? 0.0,
                data.filter((e: any) => e.label == 'NR')[0]?.value ?? 0.0,
                data.filter((e: any) => e.label == 'P')[0]?.value ?? 0.0
            ]

            for (var i = 0; i < 6; i++) {
                backgroundColor.push(CommonUtilities?.chartColors[i]);
            }

        }

        if (name == "horBarIndicator") {
            LabelName = 'Sales by format for period'

            console.log(data[0]?.values)
            for (var i = 0; i < data[0]?.values?.length; i++) {
                ChartLabel_list.push(data[0]?.values[i]?.label)
                ChartData_list.push(data[0]?.values[i]?.value)
                backgroundColor.push(CommonUtilities?.chartColors[i]);
            }
        }

        if (name == "pieChartIndicator") {

            console.log(name)
            console.log(data)
            for (var i = 0; i < data?.length; i++) {
                ChartLabel_list.push(data[i]?.key)
                ChartData_list.push(data[i]?.y)
                backgroundColor.push(CommonUtilities?.chartColors[i]);
            }
        }

        var scalesName = {
            x: {
                title: {
                    display: true,
                    text: xName,
                    font: {
                        size: 14,
                        weight: 'bold',
                    },
                },
            },
            y: {
                title: {
                    display: true,
                    text: yName,
                    font: {
                        size: 14,
                        weight: 'bold',
                    },
                },
            },
        }

        const options = {
            layout: { padding: { top: 0 } },
            plugins: { elements: { bar: { borderWidth: 0, }, } },
            scales: scalesName
        };


        var dataObj = {
            labels: ChartLabel_list,
            datasets: [
                {
                    label: LabelName,
                    data: ChartData_list,
                    borderColor: backgroundColor,
                    backgroundColor: backgroundColor,
                    yAxisID: 'y',
                }
            ]
        };

        return { options: options, data: dataObj };
    }



    const data_op = {
        labels: ["January", "February", "March", "April", "May"],
        datasets: [
            {
                label: "Sales 2025",
                data: [300, 500, 400, 700, 600],
                backgroundColor: "rgba(54, 162, 235, 0.7)",
                stack: "Stack 0",
            },
            {
                label: "Expenses 2025",
                data: [200, 300, 350, 400, 450],
                backgroundColor: "rgba(255, 99, 132, 0.7)",
                stack: "Stack 0",
            },
            {
                label: "Profit 2025",
                data: [100, 200, 50, 300, 150],
                backgroundColor: "rgba(75, 192, 192, 0.7)",
                stack: "Stack 1", // Different stack (optional)
            },
        ],
    };

    const options_op = {
        responsive: true,
        indexAxis: "y",
        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: true,
                text: "Stacked Bar Chart Example",
            },
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };


    const CallStackChart = (data: any, name: any) => {
        const options = {
            responsive: true,
            indexAxis: "y",
            plugins: {
                legend: {
                    position: "top",
                },
                title: {
                    display: true,
                    text: "Stacked Bar Chart Example",
                },
            },
            scales: {
                x: {
                    stacked: true,
                },
                y: {
                    stacked: true,
                },
            },
        };

        var data_object = {}

        if (name == "horStackBarIndicator") {
            console.log(data)

            var obj_data = []
            var obj_Final_data = []

            for (var i = 0; i < data?.length; i++) {
                var index_final_obj = []
                for (var y = 0; y < data[i]?.values?.length; y++) {
                    var index_obj = {
                        format: data[i].key,
                        label: data[i]?.values[y].label,
                        value: data[i]?.values[y].value
                    }
                    index_final_obj?.push(data[i]?.values[y].value)

                    obj_data.push(index_obj)
                }

                obj_Final_data.push({ label: data[i].key, data: index_final_obj, backgroundColor: CommonUtilities?.chartColors[i], stack: "Stack 0" })
            }

            console.log(obj_Final_data)

            console.log(data_op)
            //console.log(obj_data)
            const distinctFormats = Array.from(
                new Set(obj_data.map((item: any) => item.label))
            );
            console.log(distinctFormats)

            data_object = {
                labels: distinctFormats,
                datasets: obj_Final_data
            }
        }

        return { data: data_object, options: options };

    }

    return (

        <Drawer
            open={detail.indicatorChartDetail}
            direction='right'
            className='react-drawer full-height-vh100  allowHscroll allowVscroll'
            onClose={closeIndicatorChartDrawer}
            size={800}>


            <div className="ws-8 pull-right allowHscroll allowVscroll'">
                <div className="ws-12 box landing full-height-vh100 ">
                    <div className="box-header-main">
                        <h2 className='ws-2 pull-left'>{detail?.indicatorSelected ?? "Indicator"}</h2>

                        <div className='ws-5 pull-left white text-bold'>
                            <button className="icon-btn info pull-left " onClick={prevPeriod}><i className="icon-arrow-left"></i> </button>
                            <span className='white mt pt ws-7 pull-left'>Period   {Filter.SimplemonthAndDayYear(selectPeriod?.periodFrom)}  -   {Filter.SimplemonthAndDayYear(selectPeriod?.periodTo)} </span>
                            <button className="icon-btn info pull-left" onClick={nextPeriod}><i className="icon-arrow-right"></i> </button>
                        </div>
                    </div>

                    <div className="pm ws-12 allowHscroll allowVscroll full-height-vh90">
                        <div className="ws-12 pm pts" data-ng-show="contractRefNum">
                            <fieldset className="scheduler-border p0 m0">
                                <legend className="scheduler-border">
                                    <h2>Contract Info </h2>
                                </legend>

                                <div className="ws-12 pm">

                                    <div className="ws-4">
                                        <label className="control-label ws-5 text-right text-bold" > Contract Code :</label>
                                        <div className="label-entries ws-7 text-center"> {contractDetail?.contractRefNum} </div>
                                    </div>

                                    <div className="ws-4">
                                        <label className="control-label ws-5 text-right text-bold" > Contract Name : </label>
                                        <div className="label-entries ws-7 text-center">{contractDetail?.contractTitle}  </div>

                                    </div>

                                    <div className="ws-4">
                                        <label className="control-label ws-5 text-right text-bold" > Contract Status:</label>
                                        <div className="label-entries ws-7 text-center">  {contractDetail?.contractStatus}</div>
                                    </div>
                                </div>

                            </fieldset>
                        </div>

                        {<div className='ws-12 pm'>
                            <div className='ws-12 box'>
                                <VerticalBarChart chartPassedData={CallChart(barIndicator, "barIndicator")} />
                            </div>
                        </div>}

                        {pieChartIndicator?.length > 0 && <div className='ws-12 pm'>
                            <div className='ws-12 box'>
                                <PieChart chartPassedData={CallChart(pieChartIndicator, "pieChartIndicator")} />
                            </div>
                        </div>}

                        {horBarIndicator?.length > 0 && <div className='ws-12 pm'>
                            <div className='ws-12 box'>
                                <StackedBarChart chartPassedData={CallStackChart(horBarIndicator, "horStackBarIndicator")} />
                            </div>
                        </div>}

                        {(pieChartIndicator?.length > 0) && (horBarIndicator?.length > 0) && <div className="alert" >  No results found for these criterias   </div>}

                        <div className="box-footer">
                            <button className="icon-btn delete" onClick={closeIndicatorChartDrawer}> Close</button>
                        </div>

                    </div>

                </div>

            </div>
        </Drawer>
    )
}